// extracted by mini-css-extract-plugin
export default {"statusLoadingComp":"StatusHistory_statusLoadingComp__xsFxI","lds-default":"StatusHistory_lds-default__9tlhi"};